import { useContext, useEffect } from 'react';

import { useSubscription as useApolloSubscription } from '@apollo/react-hooks';

import UFOInteractionContext from '@atlaskit/react-ufo/interaction-context';

import getOperationName from '../utils/get-operation-name';

export const useSubscription: typeof useApolloSubscription = (...args) => {
	const ufoContext = useContext(UFOInteractionContext);

	const apolloResult = useApolloSubscription(...args);

	const [query] = args;
	const operationName = getOperationName(query);

	const isLoading = apolloResult?.loading;

	useEffect(() => {
		if (isLoading) {
			return ufoContext?.hold(operationName);
		}
	}, [isLoading, operationName, ufoContext]);

	return apolloResult;
};
